import React, { createContext, useContext } from 'react';
import { BlogPost } from '@/types';

export interface InitialData {
  posts?: BlogPost[];
  post?: BlogPost | null;
  relatedPosts?: BlogPost[];
  trustSection?: any;
  siteSettings?: Record<string, any>;
  cohorts?: any[];
  practitioners?: any[];
  trackingEnabled?: boolean;
}

const InitialDataContext = createContext<InitialData | null>(null);

export const InitialDataProvider: React.FC<{
  initialData?: InitialData | null;
  children: React.ReactNode;
}> = ({ initialData, children }) => {
  const value = initialData !== undefined
    ? initialData
    : (typeof window !== 'undefined' ? (window as any).__INITIAL_DATA__ : null);

  return (
    <InitialDataContext.Provider value={value}>
      {children}
    </InitialDataContext.Provider>
  );
};

export const useInitialData = (): InitialData | null => {
  const context = useContext(InitialDataContext);
  if (context !== undefined && context !== null) return context;
  if (typeof window !== 'undefined' && (window as any).__INITIAL_DATA__) {
    return (window as any).__INITIAL_DATA__;
  }
  return null;
};
